import { createGlobalStyle } from "styled-components";
import { Marquee } from "./ui/animations";

const theme = {
  colors: {
    // black: "#141414",
    black: "#0b0b0b",
    blackLinghter: "##121212",
    white: "#FFFFFF"
  },
  shadows: {
    large: "0px 0px 100px rgba(0, 0, 0, 0.7)"
  }
};

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Fira+Sans:400,900&subset=latin-ext');
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,700&subset=latin-ext');
  body {
    font-family: 'Fira Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizelegibility;
    color: ${theme.colors.white};
    background-color: ${theme.colors.black};
    overflow-x: hidden !important;
    overflow-y: auto;
    width: 100vw;
    position: relative;
  }
`;

export { GlobalStyle, theme };
